import { createAsyncThunk } from '@reduxjs/toolkit';
import { EApiStatuses } from '../../../constants';
import {IError, IPageActionsPayload} from '../../../models/inner-models';
import {IDownloadZip, IRestorePayload} from '../../../models/models';
import { EBackups, EPlatformNames } from '../../constants';
import { addPlatformIdentifier } from '../../functions';
import instance from '../../middlewares/api';

const getNotionActions = createAsyncThunk(
  addPlatformIdentifier(EBackups.transferRepoData, EPlatformNames.notion),
  async (payload: IPageActionsPayload, thunkAPI) => {
    try {
      const response = await instance.post(`user/get-actions?page=${payload.page}&perPage=${payload.perPage}`,
        {platform: EPlatformNames.notion, id:payload.itemId});
      return (!response?.data?.result || response.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({ error: response?.data?.message || 'Error on data load. Try later' }) : response.data.result;
    } catch (err) {
      const error = err as IError
      return thunkAPI.rejectWithValue({error: error.message});
    }
  }
);

const restoreNotionBackup = createAsyncThunk(
  addPlatformIdentifier(EBackups.restoreBackup, EPlatformNames.notion),
  async (pageRestore: IRestorePayload, thunkAPI) => {
    try {
      const resp = await instance.post('notion/restore-boards', pageRestore);
      return (!resp?.data || resp.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({error: resp?.data?.message || 'Error on data restore. Try later'}) : resp.data;
    } catch (err) {
      const error = err as IError
      return thunkAPI.rejectWithValue({error: error.message});
    }
  }
);

const downloadNotionZip = createAsyncThunk(
  addPlatformIdentifier(EBackups.downloadZip, EPlatformNames.notion),
  async ({versionId,workspaceId}: IDownloadZip, thunkAPI) => {
    try {
      const resp = await instance.post('notion/notion-get-zip', {workspaceVersionId:versionId,workspaceId});
      return (!resp?.data?.result || resp.data.status !== EApiStatuses.SUCCESS) ?
        thunkAPI.rejectWithValue({message: resp?.data?.message, status: resp?.data?.status}) : resp.data.result;
    } catch (err) {
      const error = err as IError
      return thunkAPI.rejectWithValue({error: error.message});
    }
  }
);

export { getNotionActions, restoreNotionBackup, downloadNotionZip };
